import React from "react";

import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { deletePayrolls, postCalculatePayrolls } from "../../../../../MyApi/hr/payrolls";

import icons from "../../../../../Data/icons";

const SinglePayrolls = ({ Payroll, classes, refetch , index }) => {
  const { id, month, count, paid ,deserved_amount ,calculate} = Payroll;


    
  const EyeIcon = icons.eye;
  const CalculatorIcon = icons.cal

  const mutation = useMutation(
    ["deletepayrolls", id],
    () => deletePayrolls(id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.data.response.message}`);
      },
    }
  );
  const mutationCalc = useMutation(
    "postCalculatePayrolls",
    (postData) => postCalculatePayrolls(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);

      },
      onError: (error) => {
        toast.error(`${error.data.response.message}`);
      },
    }
  );

  const handlePostRequest =()=>{
    mutationCalc.mutate({
      month:month
    })
      }

  const deletePost = () => {
    mutation.mutate();
  };

  return (  

    <div class="box-col-6 col-md-6 col-lg-12 col-xl-4 ">
      <div className={`custom-card card` }>
          <div class="text-center profile-details">
            <h4>{month}</h4>
          </div>
        <ul as="ul" class="simple-list card-social list-group list-group">
         {count > 0 && <li class="list-group-item"><Link to={`${process.env.PUBLIC_URL}/payrolls/${month}`}><EyeIcon/></Link></li>}
          {calculate && <li class="list-group-item" > <button onClick={handlePostRequest} className="btn p-0"><CalculatorIcon/> </button> </li>}
        </ul>
        <div className="row card-footer">
          <div className="col-4 col-sm-4">
            <h6>paid</h6>
            <h3 className="counter">{paid}</h3>
          </div>
          <div className="col-4 col-sm-4">
            <h6>count</h6>
            <h3>
              <span className="counter">{count}</span>
            </h3>
          </div>
          <div className="col-4 col-sm-4">
            <h6>Total Post</h6>
            <h3>
              <span className="counter">{deserved_amount}</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePayrolls;
